import { formatDate } from '@/core/helpers';
import { normalizeDateFE } from '@/core/normalization';
import { NormalizedSellerFilingReport } from '@/core/types';
import { useTranslation } from 'react-i18next';

interface Props {
  report: NormalizedSellerFilingReport;
}

export const SellerFilingReportPeriod = ({ report }: Props) => {
  const { t } = useTranslation();

  let formatStr = 'MMM yyyy';

  if (report.period.type === 'year') {
    return (
      <div>
        <span>{t('Year')}</span>&nbsp;
        <span>
          {formatDate(normalizeDateFE(report.period.from_date), 'yyyy')}
        </span>
      </div>
    );
  }

  if (report.period.type === 'quarter') {
    formatStr = 'QQQ yyyy';
  }

  return (
    <div>
      <span>
        {formatDate(normalizeDateFE(report.period.from_date), formatStr)}
      </span>
    </div>
  );
};
